import React, { Component } from 'react';
import * as _ from 'lodash-es';
import axios from 'axios';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Cookies from 'js-cookie';
import { formatStorePrice } from '../../../utils/ecommerce/currency.js';
import '../ppUtilities.js';
import ppUtilities from '../ppUtilities';
import CartHelper from '../CartHelper';
import Loader from '../components/global/Loader.js';
import BundlesCardDataLayer from './bundlesCardDataLayer';
import { Analytics } from '../../../utils/common/analytics';

const _cartHelper = new CartHelper();

class BundleCards extends Component {
	constructor(props) {
		super(props);
		this.bundleLoadPromise = new Promise((resolve) => (this.bundleLoadPromiseResolve = resolve));
		this.analytics = Analytics.getInstance();
		this.analytics.setLocalItem('bundlePromises', [...(this.analytics.getLocalItem('bundlePromises') || []), this.bundleLoadPromise]);
		this.preData = true;
		this.staticPriceInfo = {};
		this.state = {
			prodConfig: null,
			bundleSpinOn: false,
		};
		this.addBundleSpin = false;
		this.bundleAdded = false;
		this.addToCart = this.addToCart.bind(this);
		this.handleAddBundle = this.handleAddBundle.bind(this);
		console.info('COMP Bundles :: v.2.rc');
	}

	async componentDidMount() {
		// find card wrapper to remove Hidden class
		let appWrapper = this.props.appWrapper;
		let cardWrapper = appWrapper.closest('.bundle-card');
		if (cardWrapper) {
			cardWrapper.classList.remove('hidden');
		}

		let prodConfig = await this.getProdPricing();
		this.bundleLoadPromiseResolve({ prodConfig: prodConfig, bundleInfo: this.props.bundleInfo });
		if (this.props.isLast) {
			Promise.all(this.analytics.getLocalItem('bundlePromises')).then((dataList) => {
				const items = Analytics.toItems(dataList, Analytics.dataType.BUNDLE);
				const firstProdConfig = dataList?.find((data) => !!data?.prodConfig)?.prodConfig;
				this.analytics.addPageInfo({
					pageType: 'product',
					pageSubType: 'bundle-product-pricing',
					ecommerce: {
						storeType: Analytics.storeType.OMNI,
						storeFront: Analytics.toStoreFront(firstProdConfig?.zone),
						distributorNumber: firstProdConfig?.distributorNumber,
					},
				});
				this.analytics.addEvent(Analytics.eventType.PRODUCT_VIEW, { items });
			});
		}
		this.preData = false;
		this.setState({ prodConfig }, () => new BundlesCardDataLayer(this.props, prodConfig, this.props.total));
	}

	componentDidUpdate() {
		const { prodConfig } = this.state;
		if (Array.isArray(this.props.initCardData) && 'currency' in prodConfig) {
			this.initCartConfig();
		}
	}

	initCartConfig() {
		const { prodConfig } = this.state;
		// Prospect Id
		let prospectIdObj = JSON.parse(localStorage.getItem('prosId'));

		let currencyPlacement = prodConfig.currencyPlacement ? prodConfig.currencyPlacement : 'before';
		let eCartData = {
			currency: prodConfig.currency,
			distributorNumber: prodConfig.distributorNumber,
			istApiUrl: window.storeVariables.eCommUrl,
			locale: prodConfig.locale,
			zone: prodConfig.zone,
			metadata: {
				currency: { currencyCode: prodConfig.currency, currencyPlacement, currencySymbol: prodConfig.currencySymbol },
				formattedLocale: prodConfig.formattedLocale,
				isOmni: prodConfig.isOmni,
				storeDomain: prodConfig.storeDomain,
				sfReferenceId: Cookies.get('sf_id') || Cookies.get('epn_id') || '',
				customerProspectId: (_.isObject(prospectIdObj) && prospectIdObj.value) || '',
			},
		};
		this.props.initCart(eCartData);
	}

	async getProdPricing() {
		const { bundleInfo } = this.props;
		let prodsConfig = null;
		this.staticPriceInfo = JSON.parse(bundleInfo.staticPrice);
		if (this.staticPriceInfo.displayPriceBool == 'true') {
			let data = bundleInfo.prodConfigArr.map((prod) => {
				return JSON.parse(prod);
			});
			prodsConfig = {
				data,
			};
			return prodsConfig;
		}

		let payload = {
			country_code: this.props.country_code || 'US',
			distributor: this.getDistributorConfig(),
			data: [],
		};

		if ('prodConfigArr' in bundleInfo && bundleInfo.prodConfigArr.length) {
			payload.data = bundleInfo.prodConfigArr.map((config) => {
				let prod = JSON.parse(config);
				return {
					SKU: prod.sku,
					cfPath: prod.cfLink,
				};
			});
		}

		await axios({
			url: '/bin/esri/storebundledata',
			method: 'post',
			data: payload,
			responseType: 'json',
		})
			.then((resp) => {
				if (resp.status == 200 && resp.data) {
					prodsConfig = resp.data;
				} else {
					console.error('Bundle API Error');
					prodsConfig = { error: 'Bundle API Error' };
					this.analytics.addEvent(Analytics.eventType.ERROR, {
						errorDesc: `Bundle API Error`,
					});
				}
			})
			.catch((error) => {
				console.error('Catched Bundled API error: ', error);
				prodsConfig = { error: 'Bundle API Error' };
				this.analytics.addEvent(Analytics.eventType.ERROR, {
					errorDesc: `${error?.name}: ${error?.message}`,
				});
			});

		return prodsConfig;
	}

	getDistributorConfig() {
		const _host = location.host;

		// if it is preview but it is esri.com
		if (`${_host}/` === 'preview.esri.com/') {
			// needs fowardslash for cases like (https://preview.esri.com.tr/tr-tr/ -- turkey)
			return false;
		}
		// Is distributor
		return true;
	}

	async handleAddBundle() {
		this.setState({ bundleSpinOn: true }, () => {
			this.addToCart();
		});
	}

	async addToCart() {
		if (this.bundleAdded) {
			return;
		}
		this.bundleAdded = true;
		const { prodConfig } = this.state;
		const { bundleInfo, initCardData, cart } = this.props;
		let _bundleAllData = Object.assign({}, bundleInfo);
		_bundleAllData.config = prodConfig;
		const istApiUrl = initCardData.istApiUrl;
		const bundleTitle = bundleInfo.title;
		let cartId = _cartHelper.getCartId();
		const items = Analytics.toItems([{ prodConfig, bundleInfo }], Analytics.dataType.BUNDLE, { includeQty: true });
		if (cartId == undefined) {
			const requestModel = _cartHelper.getNewCartReqModel(initCardData, prodConfig, cart, bundleTitle);
			addToGlobalNavCart(prodConfig);
			await this.props.createCart(istApiUrl, requestModel, _bundleAllData);
			this.analytics.addEvent(Analytics.eventType.CART_ADD_OPEN, {
				cartID: _cartHelper.getCartId(),
				items: items,
			});
		} else {
			const requestModel = _cartHelper.getNewCartReqModel(initCardData, prodConfig, cart, bundleTitle);
			addToGlobalNavCart(prodConfig);
			await this.props.addToExistingCart(istApiUrl, requestModel, cartId, _bundleAllData);
			this.analytics.addEvent(Analytics.eventType.CART_ADD, {
				cartID: cartId,
				items: items,
			});
		}

		//* Helper functions
		function addToGlobalNavCart(prodConfig) {
			let cartTotalQty = 0;
			prodConfig.data.forEach((item) => {
				cartTotalQty = cartTotalQty + item.qty;
			});
			try {
				window.esriShoppingCart.addItemsToCart(cartTotalQty);
			} catch (e) {
				console.warn('[Warning: issue with global nav cart:] ', e);
				this.analytics.addEvent(Analytics.eventType.ERROR, {
					errorDesc: `${e?.name}: ${e?.message}`,
				});
			}
		}
	}

	formatPrice(price, priceTerm) {
		if (!this.props.initCardData || Array.isArray(this.props.initCardData || typeof this.props.initCardData !== 'object')) {
			return '';
		}

		const metadata = this.props.initCardData?.metadata;
		const isWholeNumber = price % 1 === 0;
		const currencyOptions = isWholeNumber ? { maximumFractionDigits: 0 } : undefined;
		const formattedPrice = formatStorePrice(price, metadata?.formattedLocale, metadata?.currency, currencyOptions);
		return `${formattedPrice} ${priceTerm}`;
	}

	render() {
		if (this.preData) {
			return (
				<div class="recommended-card-text-wrapper">
					<div class="recommended-card-content-text">
						<Loader noGrid={true} />
					</div>
				</div>
			);
		}

		let { prodConfig } = this.state;
		if (prodConfig.error) {
			return (
				<div class="recommended-card-text-wrapper">
					<div class="recommended-card-content-text">
						<p class="leader-half trailer-half font-size-0">{this.props.bundleInfo.bundleErrorMessg}</p>
					</div>
				</div>
			);
		}

		if (!prodConfig || !prodConfig.data || !prodConfig.data.length) {
			return (
				<div class="recommended-card-text-wrapper">
					<div class="recommended-card-content-text">
						<Loader noGrid={true} />
					</div>
				</div>
			);
		}

		const { bundleInfo } = this.props;
		let staticPriceInfo = this.staticPriceInfo || JSON.parse(bundleInfo.staticPrice);
		let parsedProds = bundleInfo.prodConfigArr.map((config) => JSON.parse(config));
		let bundlePrice = 0;
		let dataWQty = [];
		let displayStaticPrice = staticPriceInfo.displayPriceBool == 'true' ? true : false;
		let apiSentPrice = false;
		let prodConfigData = [...prodConfig.data];
		let products = prodConfigData.map((prod) => {
			if (displayStaticPrice) {
				let prodQty = prod.qty > 0 ? `(${prod.qty})` : '';
				return (
					<li class="font-size--1">
						{prod.productLable} {prodQty}
					</li>
				);
			}
			let currProd = parsedProds.filter((parsedConfig) => parsedConfig.sku == prod.SKU);

			if (!currProd.length) {
				return null;
			}
			let currObj = prod;
			if (!apiSentPrice && prod.price && Number(prod.price) > 0) {
				apiSentPrice = true;
			}
			currObj.qty = currProd[0].qty;
			dataWQty.push(currObj);
			let skuTotal = prod.price ? Number(prod.price) * currProd[0].qty : 0;
			bundlePrice = bundlePrice + skuTotal;
			if (!currProd[0].qty) {
				return <li class="font-size--1">{currProd[0].productLable}</li>;
			}
			return (
				<li class="font-size--1">
					{currProd[0].productLable} {`(${currProd[0].qty})`}
				</li>
			);
		});

		prodConfig.data = dataWQty.length ? dataWQty : prodConfig.data;

		let styledPrice = this.formatPrice(bundlePrice, bundleInfo.priceTerm);
		if (displayStaticPrice || bundlePrice == 0) {
			styledPrice = staticPriceInfo.displayPrice == 'undefined' ? '' : staticPriceInfo.displayPrice;
		}
		if (!apiSentPrice) {
			styledPrice = '';
		}
		let locRegx = /\/([a-z]{2}-[a-z]{2})\//gm;
		let loc = locRegx.exec(location.pathname);
		loc = loc ? loc[1] : 'en-us';
		let addBundleSpin = this.state.bundleSpinOn;

		if (this.bundleAdded) {
			this.bundleAdded = false;
			this.setState({
				bundleSpinOn: false,
				bundleAddedMssg: bundleInfo.bundleAddedMssg,
			});
		}

		let moreInfoMssg = bundleInfo.moreinfo ? bundleInfo.moreinfo : false;
		moreInfoMssg = this.state.bundleAddedMssg ? this.state.bundleAddedMssg : moreInfoMssg;

		return (
			<React.Fragment>
				<div class="recommended-card-text-wrapper">
					<div class="recommended-card-content-text">
						<h2 class="card-title leader-half trailer-half font-size-2">{bundleInfo.title}</h2>
					</div>
					<div class="recommended-card-content-subtitle avenir-regular trailer-1">
						<p class="font-size--1 trailer-0" dangerouslySetInnerHTML={{ __html: bundleInfo.desc }}></p>
						<ul class="bundle-card-list">{products}</ul>
					</div>
				</div>
				<div class="recommended-card-price-wrapper">
					<div class="recommended-card-content-purchase">{moreInfoMssg && <p class="purchase-text trailer-0">{moreInfoMssg}</p>}</div>
					<div class="recommended-card-content-price">
						<p class="trailer-0 font-size-1">{styledPrice || ''}</p>
						<div class="calcite-button-wrapper" data-event="track-component" data-component-name="buy now" data-component-link-type="button">
							{bundlePrice > 0 && !displayStaticPrice ? (
								<calcite-button
									onClick={this.handleAddBundle}
									class="cta-trigger"
									appearance="solid"
									data-component-link={bundleInfo.ctaTrigger}>
									{bundleInfo.ctaTrigger}
									{addBundleSpin && <span style={{ paddingLeft: '6px' }} className="icon-ui-loading-indicator spin"></span>}
								</calcite-button>
							) : (
								<calcite-button href={staticPriceInfo.ctaRedirect} class="cta-trigger" appearance="solid">
									{staticPriceInfo.ctaLabel}
								</calcite-button>
							)}
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps({ initCardData, cart }) {
	return {
		initCardData,
		cart,
	};
}

export default connect(mapStateToProps, actions)(BundleCards);

// v.1.1
